import React from "react";
import MapSection from "./MapSection";
import OrganizationHero from "./OrganizationHero";
import ContactSection from "./ContactSection";
import { Card, CardContent, CardHeader, CardTitle } from "../ui/card";
import { useI18n } from "../../hooks/useI18n";
import type { OrganizationPageData as BusinessPageData } from "../../presentation/organizations/organizationPage.types";
import { selectDeterministicItem } from "../../domain/shared/commerce.utils";

const OrganizationAboutPage: React.FC<{ business: BusinessPageData }> = ({ business }) => {
  const { text, t } = useI18n();
  const heroImage = selectDeterministicItem(business.images, business.id)?.url
    ?? "/assets/images/placeholder.jpg";

  return (
    <>
      <OrganizationHero
        name={t(text.business.aboutHero, { name: business.name })}
        description={text.business.aboutSubtitle}
        heroImage={heroImage}
        height="medium"
      />

      <section className="bg-white py-16">
        <div className="container mx-auto max-w-3xl text-center">
          <h2 className="mb-8 text-3xl font-semibold">{text.business.whoWeAre}</h2>
          <p className="mb-12 text-lg text-muted-foreground">{business.longDescription}</p>

          <Card>
            <CardHeader>
              <CardTitle className="text-center">{text.nav.contact}</CardTitle>
            </CardHeader>
            <CardContent>
              <ContactSection
                address={business.contactInfo.address}
                phones={[business.contactInfo.phone]}
                emails={[business.contactInfo.email]}
                labels={{ address: text.contact.address, phone: text.contact.phone, email: text.contact.email }}
              />
            </CardContent>
          </Card>
          <div className="mt-6">
            {business.location ? (
              <MapSection coordinates={{ latitude: business.location.lat, longitude: business.location.lng }} address={business.contactInfo.address} name={business.name} height="320px" />
            ) : (
              <p className="text-center text-muted-foreground">{text.business.locationUnavailable}</p>
            )}
          </div>
        </div>
      </section>
    </>
  );
};

export default OrganizationAboutPage;
